import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import './MoodMessenger.css';

const moodMessages = {
  Happy: "Seeing you happy makes my entire world brighter. 🌞",
  Sad: "It's okay to feel low sometimes. I'm always here for you. 🤍",
  Angry: "Take your time, love. I'll wait patiently with open arms. 🕊️",
  Stressed: "Breathe. I'm sending you strength and love right now. 💆‍♀️💖",
  Excited: "I love your spark — let's turn that excitement into magic! ✨"
};

export default function MoodMessenger() {
  const [mood, setMood] = useState("");
  const [message, setMessage] = useState("");
  const audioRef = useRef(null);

  const handleMoodClick = (selectedMood) => {
    setMood(selectedMood);
    setMessage(moodMessages[selectedMood]);

    // Attempt to play audio
    if (audioRef.current) {
      audioRef.current.volume = 0.3; // Safe volume
      audioRef.current.play().catch((err) => {
        console.warn("Browser prevented auto-play:", err);
      });
    }
  };

  return (
    <motion.div className="mood-container"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <h2>How are you feeling today, Toto ji?</h2>
      <div className="mood-buttons">
        {Object.keys(moodMessages).map((m) => (
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            key={m}
            onClick={() => handleMoodClick(m)}
          >
            {m}
          </motion.button>
        ))}
      </div>

      {message && (
        <motion.div
          className="mood-message"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <p><strong>{mood}:</strong> {message}</p>
        </motion.div>
      )}

      {/* Background music */}
      <audio
        ref={audioRef}
        src="/background.mp3"
        preload="auto"
        loop
      />
    </motion.div>
  );
}
